import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { apiBaseUrl } from '../../util/api';

// ================ Action types ================ //

export const UPLOAD_BULK_LISTINGS_REQUEST = 'app/BulkUploadPage/UPLOAD_BULK_LISTINGS_REQUEST';
export const UPLOAD_BULK_LISTINGS_SUCCESS = 'app/BulkUploadPage/UPLOAD_BULK_LISTINGS_SUCCESS';
export const UPLOAD_BULK_LISTINGS_ERROR = 'app/BulkUploadPage/UPLOAD_BULK_LISTINGS_ERROR';
export const RESET_UPLOAD_STATE = 'app/BulkUploadPage/RESET_UPLOAD_STATE';

// ================ Reducer ================ //

const initialState = {
    uploadInProgress: false,
    uploadError: null,
    uploadSuccess: false,
    uploadedListings: [],
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case UPLOAD_BULK_LISTINGS_REQUEST:
            return {
                ...state,
                uploadInProgress: true,
                uploadError: null,
                uploadSuccess: false,
            };
        case UPLOAD_BULK_LISTINGS_SUCCESS:
            return {
                ...state,
                uploadInProgress: false,
                uploadSuccess: true,
                uploadedListings: payload,
            };
        case UPLOAD_BULK_LISTINGS_ERROR:
            return {
                ...state,
                uploadInProgress: false,
                uploadError: payload,
            };
        case RESET_UPLOAD_STATE:
            return initialState;
        default:
            return state;
    }
}

// ================ Action creators ================ //

export const uploadBulkListingsRequest = () => ({ type: UPLOAD_BULK_LISTINGS_REQUEST });
export const uploadBulkListingsSuccess = listings => ({
    type: UPLOAD_BULK_LISTINGS_SUCCESS,
    payload: listings,
});
export const uploadBulkListingsError = error => ({
    type: UPLOAD_BULK_LISTINGS_ERROR,
    payload: error,
    error: true,
});
export const resetUploadState = () => ({ type: RESET_UPLOAD_STATE });

// ================ Thunks ================ //

export const uploadBulkListings = file => (dispatch, getState, sdk) => {
    dispatch(uploadBulkListingsRequest());

    const formData = new FormData();
    formData.append('file', file);

    const url = `${apiBaseUrl()}/api/bulk-upload`;

    return fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(err.message || 'Upload failed');
                }).catch(() => {
                    throw new Error(`Upload failed with status: ${response.status}`);
                });
            }
            return response.json();
        })
        .then(data => {
            dispatch(uploadBulkListingsSuccess(data.listings));
            return data;
        })
        .catch(e => {
            log.error(e, 'bulk-upload-failed');
            dispatch(uploadBulkListingsError(storableError(e)));
            throw e;
        });
};
